// Module
var code = "<svg fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" viewBox=\"0 0 24 24\" stroke=\"currentColor\"><path d=\"M12 4v16m8-8H4\"/></svg>";
// Exports
module.exports = code;